import React, { useState } from 'react';

import { GetLastEditorDto } from '../../common/pokCore/autogenerated/pokApiClient';
import { useNotifications } from '../../common/hooks/useNotifications';

import { LastEditorInfoDisplay } from './LastEditorInfoDisplay';

export default (props: {
  id: string;
  className?: string;
  iconSize?: number;
  placement?: 'left' | 'right' | 'top' | 'bottom';
  method: (id: string) => Promise<GetLastEditorDto>;
  additionalText?: string;
}) => {
  const [lastEditor, setLastEditor] = useState<GetLastEditorDto>();
  const [isLoading, setIsLoading] = useState(false);
  const notifications = useNotifications();

  const getLastEditor = () => {
    if (!props.id) {
      return;
    }
    setIsLoading(true);
    setLastEditor(undefined);
    props
      .method(props.id)
      .then(info => {
        setLastEditor(info);
        setIsLoading(false);
      })
      .catch(errorResponse => {
        notifications.caughtError(errorResponse);
        setIsLoading(false);
      });
  };

  return (
    <LastEditorInfoDisplay
      lastEditor={lastEditor}
      isLoading={isLoading}
      onEnter={getLastEditor}
      className={props.className}
      iconSize={props.iconSize}
      placement={props.placement}
      additionalText={props.additionalText}
    />
  );
};
